// @flow

import Service from '../service';
import type { EdeEligibilitySignType, EdeEligibilityResponseType } from '../../types/ede/eligibility';

export default class EligibilityService extends Service {
  // TODO(hum): Remove signature name argument as API doesn't use signature name value
  postEligibility(ifp_app_id: string, {
    signatureName,
    requestMedicaidDeterminationMemberIds,
  }: EdeEligibilitySignType):
    Promise<EdeEligibilityResponseType> {
    return this.api.post(`${this.baseUrl}/ede/eligibility/${ifp_app_id}`, { signatureName, requestMedicaidDeterminationMemberIds })
      .then(res => res.data);
  }

  // This is preferred over getEligibility prior to enrollment
  // This method fetches a fresh eligibility determination from the DE fetchEligibility API
  // It modifies ede_application and ede_member DB rows, so not a GET
  putEligibility(ifp_app_id: string): Promise<EdeEligibilityResponseType> {
    return this.api.put(`${this.baseUrl}/ede/eligibility/${ifp_app_id}`)
      .then(res => res.data);
  }

  getEligibility(ifp_app_id: string): Promise<EdeEligibilityResponseType> {
    return this.api.get(`${this.baseUrl}/ede/eligibility/${ifp_app_id}`)
      .then(res => res.data);
  }
}
